<app-core-popup
  [dialogStyle]="{ width: '45rem' }"
  [header]="'case.patient-informations.patient-emails.header' | translate"
  [saveText]="'common.save' | translate"
  (chooseOn)="save()"
  #corePopup
>
  <div class="table-responsive active-projects style-1">
    <p-table
      [value]="patientEmails"
      [(selection)]="selectedPatientEmails"
      selectionMode="multiple"
      [scrollable]="true"
      scrollHeight="30vh"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem" scope="col"><p-tableHeaderCheckbox /></th>

          <th scope="col">
            {{
              "case.patient-informations.patient-emails.email-type" | translate
            }}
          </th>
          <th scope="col">
            {{ "case.patient-informations.patient-emails.email" | translate }}
          </th>
          <th scope="col">
            {{
              "case.patient-informations.patient-emails.priority" | translate
            }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-contact>
        <tr (click)="$event.stopPropagation()" [pSelectableRow]="contact" role="button"  tabindex="-1">
          <td>
            <p-tableCheckbox [value]="contact" />
          </td>
          <td>{{ contact.type.valueObject.name.value }}</td>
          <td>{{ contact.email }}</td>
          <td>
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="contact.priority"
              disabled
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-core-popup>
